import { PaginatedRequest, PaginatedResponse } from '@/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { AgendaApi, AgendaFilter, NewAgenda } from '../models';
import { API_ATTEND_TRACK_URL } from '@/utils';
import { SlotsApi } from '../models/Agenda';
import { createBaseQueryWithReauth } from '@/services';

const agendasService = createApi({
  reducerPath: 'agendasService',
  baseQuery: createBaseQueryWithReauth(API_ATTEND_TRACK_URL),
  tagTypes: ['Agendas'],
  endpoints: (builder) => ({
    getAgendas: builder.query<
      PaginatedResponse<AgendaApi>,
      { filters?: Partial<AgendaFilter>; paginated: PaginatedRequest }
    >({
      query: ({ filters, paginated }) => ({
        url: '/agendas',
        params: {
          dateOpen: filters?.dateOpen ?? '',
          dateOpenFrom: filters?.dateOpenFrom ?? '',
          dateOpenTo: filters?.dateOpenTo ?? '',
          offset: (paginated.page - 1) * paginated.pageSize,
          limit: paginated.pageSize,
        },
      }),
      providesTags: ['Agendas'],
    }),
    createAgenda: builder.mutation<
      AgendaApi & { slots: PaginatedResponse<SlotsApi> },
      NewAgenda
    >({
      query: (data) => ({
        url: '/generate-agenda',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Agendas'],
    }),
    deleteAgenda: builder.mutation<void, string>({
      query: (agendaId) => ({
        url: `/agenda/${agendaId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Agendas'],
    }),
  }),
});

export default agendasService;
export const {
  useGetAgendasQuery,
  useCreateAgendaMutation,
  useDeleteAgendaMutation,
} = agendasService;
